import { z } from "zod";
import { autorizacaoAdminSchema, type AutorizacaoAdmin } from "./caixa";
import { id } from "./comuns";

/**
 * Oferta: itens entregues sem pagamento (ex.: para os convidados, a pedido do pastor).
 * Baixa o estoque, mas não entra no caixa nem no total arrecadado. No PDV vem com o caixa
 * do operador e precisa de autorização de ADMIN; pelo estoque, só o ADMIN lança.
 */
export const ofertaRegistrarSchema = z
  .object({
    /** UUID gerado no aparelho: reenviar o mesmo id não duplica a oferta. */
    id,
    eventoId: id,
    caixaId: id.optional(),
    itens: z
      .array(z.object({ produtoId: id, quantidade: z.number().int().min(1).max(999) }))
      .min(1, { error: "A oferta precisa ter pelo menos um item" })
      .max(100),
    solicitadoPor: z.string().trim().min(2, { error: "Informe quem pediu" }).max(120),
    observacao: z.string().trim().max(500).optional(),
    autorizacao: autorizacaoAdminSchema.optional(),
  })
  .refine((v) => new Set(v.itens.map((i) => i.produtoId)).size === v.itens.length, {
    error: "Produto repetido na oferta",
    path: ["itens"],
  });
export type OfertaRegistrarEntrada = {
  id: string;
  eventoId: string;
  caixaId?: string;
  itens: { produtoId: string; quantidade: number }[];
  solicitadoPor: string;
  observacao?: string;
  autorizacao?: AutorizacaoAdmin;
};

export const ofertaCancelarSchema = z.object({
  motivo: z.string().trim().min(3, { error: "Informe o motivo do cancelamento" }).max(300),
});
export type OfertaCancelarEntrada = z.input<typeof ofertaCancelarSchema>;
